import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { DireccionesComponent } from 'src/app/direcciones/direcciones.component';
import { general } from 'src/app/models/general';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-info-codext',
  templateUrl: './info-codext.component.html',
  styleUrls: ['./info-codext.component.css']
})
export class InfoCodextComponent implements OnInit {

  actual = environment.actual;

  logo = environment.entidad[this.actual].urlLogo
  heightLogo = environment.entidad[this.actual].heightLogo
  image = `url(${environment.entidad[this.actual].backgroundLogin})`;
  public general
  constructor(
    private servicio: UserService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private dialog: MatDialog,
    private _route: ActivatedRoute,
    private messageService: MessageService) {
    this.general = new general()
  }

  ngOnInit(): void {
    this.getdata()
  }

  getdata() {
    this.spinner.show()
    let data = {
      nit: this._route.snapshot.paramMap.get('nit')
    }
    this.servicio.httpPost('consultarcodext', data).subscribe(resp => {
      let firma = {
        numsol: this._route.snapshot.paramMap.get('numsol') ,
        codunico: resp.details[0].CODCODEUDOR,
        nit: this._route.snapshot.paramMap.get('nit'),
        token: this._route.snapshot.paramMap.get('token')
      }
      this.servicio.httpPost('firmarPagare', firma).subscribe(resp => {
        console.log(resp) 
        this.spinner.hide()
        Swal.fire({
          icon: resp.status,
          text: resp.message
        })
      })
    })
  }

}
